import React from 'react';
import { SummaryLabelledInfo } from '../labelled-info';
import {
  RightFirstRefusalLabel,
  StockRestrictionLabel,
} from '../../../reservation/reservation-utils';
import { RadioConvertUtils } from '../../../../../../utils/radio/radio';
import { BuyProcessState } from '../../../../buy-process-form-types';

interface SummaryReservationProps {
  reservation: BuyProcessState['reservation'];
}

export const SummaryReservation = ({
  reservation,
}: SummaryReservationProps) => (
  <React.Fragment>
    <SummaryLabelledInfo label="Hembud">
      {
        RightFirstRefusalLabel[
          RadioConvertUtils.boolToStr(reservation.rightFirstRefusal)
        ]
      }
    </SummaryLabelledInfo>
    <SummaryLabelledInfo label="Önskas Förköps- eller Samtyckesförbehåll?">
      {StockRestrictionLabel[reservation.stockRestrictions]}
    </SummaryLabelledInfo>
  </React.Fragment>
);
